export default __webpack_public_path__ + "static/media/ATLAS.dbcddc86.png";